<template>
  <div class="basicForm">
    <el-form ref="form" :model="form" :rules="rules" label-width="150px">
      <el-form-item label="帐号">
        <el-input v-model="form.userNumber" disabled />
      </el-form-item>
      <el-form-item label="当前余额">
        <el-input v-model="form.fBalance" disabled />
      </el-form-item>
      <el-form-item label="当前花费">
        <el-input v-model="form.fConsumption" disabled />
      </el-form-item>
      <el-form-item label="账户底额" prop="fMinBalance">
        <el-input-currency v-model="form.fMinBalance" :scale="2" />
      </el-form-item>
      <el-form-item label="订单上限">
        <el-input-currency v-model="form.fMaxConsumption" :scale="2" />
      </el-form-item>
      <el-form-item label="账户是否禁用">
        <el-checkbox v-model="form.isProhibit" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import md5 from 'md5'

export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fMinBalance: [{ required: true, message: '必填项', trigger: 'change' }]
      }
    }
  },
  computed: {
  },
  mounted: function() {
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" >
 .basicForm{
.el-input.is-disabled .el-input__inner {
     background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
}
 .flex-item {
    display: flex;
    width:95%;
    & > .el-form-item {
      flex: 0 0 25%;
      display: flex;

      & .el-input, &.el-select {
        width: 100%;
      }
    }
  }
}
</style>
